import { jsx as _jsx } from "react/jsx-runtime";
import './app.css';
import axios from 'axios';
import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const token = document.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.getAttribute('content') || '';
}
// Telas em resources/panel/pages, resolvidas pelo nome enviado pelo Laravel (Inertia::render).
const pages = require.context('./pages', true, /\.tsx$/);
createInertiaApp({
    title: (title) => (title ? `${title} · Rocket` : 'Rocket'),
    resolve: (name) => pages(`./${name}.tsx`),
    setup({ el, App, props }) {
        createRoot(el).render(_jsx(App, { ...props }));
    },
    progress: { color: '#8c52ff', showSpinner: false },
});
